import { render, staticRenderFns } from "./Letter.vue?vue&type=template&id=3951ce30&"
import script from "./Letter.vue?vue&type=script&lang=ts&"
export * from "./Letter.vue?vue&type=script&lang=ts&"
import style0 from "./Letter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports